import { errorMessages } from "../../constants";
import { buildBasePulseEvent } from "./baseEvent";
import type { EventBuilder } from "../../typings";

export const buildActivateEvent: EventBuilder = (input) => {
  const { experimentId, userAttributes, variant } = input;

  if (!experimentId) throw new Error(errorMessages.NO_EXPERIMENT_ID);
  if (!variant) throw new Error(errorMessages.NO_VARIANT_PRESENT);

  return {
    "@type": "Activate",
    object: {
      "@id": experimentId,
      "@type": "Experiment",
      attributes: userAttributes,
      status: "assigned",
      variant,
    },
    ...buildBasePulseEvent(input),
  };
};
